import getGame from './getGame';

const isMobileGame = (game = getGame()) => {
  return game === 'lineage2m' || game === 'lineagem' || game === 'h2';
};

export default isMobileGame;
